import { Vector3 } from 'three'
import TWEEN from 'three/examples/jsm/libs/tween.module.js'
import { MarkerEventType } from '../../../types/elements/visualizer/visualizerTypes'
import { WaypointMarkerModel } from './waypointMarker'

/**
 * Handles marker click event
 * @param visualizer Marker visualizer scene object
 * @param markerModel Marker Model Object
 */
function markerClickedHandler(visualizer, markerModel: WaypointMarkerModel): void {
  visualizer.moveToMarker(markerModel.mesh, { updateSpotLight: true })
  if (typeof visualizer.markerClickedCallback === 'function') visualizer.markerClickedCallback(markerModel)
}

/**
 * Handles marker mouse in event
 * @param visualizer Marker visualizer scene object
 * @param markerModel Marker Model Object
 */
function markerMouseOverHandler(visualizer, markerModel: WaypointMarkerModel): void {
  if (visualizer.markers.selectedMarkerModel.marker.meta.imageUuid !== markerModel.marker.meta.imageUuid) {
    const scale = 1.5
    const scaleVector = new Vector3(scale, scale, scale)
    new TWEEN.Tween(markerModel.mesh.scale)
      .to(scaleVector, 250)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate((scaledVector) => {
        markerModel.mesh.scale.set(scaledVector.x, scaledVector.y, scaledVector.z)
      })
      .start()
    markerModel.setMeshToHoverMaterial()
    markerModel.mesh.scale.set(scale, scale, scale)
  }
  if (typeof visualizer.markerMouseOutCallback === 'function') visualizer.markerMouseInCallback(markerModel)
  document.body.style.cursor = 'pointer'
}

/**
 * Handles marker mouse out event
 * @param visualizer Marker visualizer scene object
 * @param markerModel Marker Model Object
 */
function markerMouseOutHandler(visualizer, markerModel: WaypointMarkerModel): void {
  const tween = () => {
    const scale = 1
    const scaleVector = new Vector3(scale, scale, scale)
    new TWEEN.Tween(markerModel.mesh.scale)
      .to(scaleVector, 250)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onUpdate((scaledVector) => {
        markerModel.mesh.scale.set(scaledVector.x, scaledVector.y, scaledVector.z)
      })
      .start()
    markerModel.mesh.scale.set(scale, scale, scale)
  }

  if (visualizer.markers.selectedMarkerModel.marker.meta.imageUuid !== markerModel.marker.meta.imageUuid) {
    tween()
    markerModel.setMeshToInactiveMaterial()
  } else if (markerModel.mesh.scale.x > 1) {
    tween()
  }
  if (typeof visualizer.markerMouseInCallback === 'function') visualizer.markerMouseOutCallback(markerModel)
  document.body.style.cursor = 'default'
}

/**
 * Handles waypoint click event
 * @param visualizer Marker visualizer scene object
 * @param type MarkerEventType enum string
 * @param markerModel Marker Model Object
 */
function waypointEventCallback(visualizer, type: MarkerEventType, model: WaypointMarkerModel) {
  const markerEventFunctions = {
    [MarkerEventType.click]: markerClickedHandler.bind(null, visualizer, model),
    [MarkerEventType.mouseover]: markerMouseOverHandler.bind(null, visualizer, model),
    [MarkerEventType.mouseout]: markerMouseOutHandler.bind(null, visualizer, model),
  }
  markerEventFunctions[type]()
}

export { waypointEventCallback }
